<template>
    <el-drawer :visible.sync="show" direction="rtl" :title="title" append-to-body class="model-setting-drawer">
            <el-form :model="settings" label-width="10em" label-suffix="：" class="el-drawer-content">
                <el-form-item v-if="settings.promptTemplate" label="提示词">
                    <el-input v-model="settings.promptTemplate.content" type="textarea" :autosize="{ minRows: 5, maxRows: 20}"></el-input>
                </el-form-item>
                <el-form-item label="maxLength">
                    <el-input-number v-model="settings.maxLength" size="small" />
                    <el-slider v-model="settings.maxLength" :min="1" :max="4096"></el-slider>
                </el-form-item>
                <el-form-item label="contextLimit">
                    <el-input-number v-model="settings.contextLimit" size="small" />
                    <el-slider v-model="settings.contextLimit" :min="0" :max="10" :step="1"></el-slider>
                </el-form-item>
                <el-form-item label="temperature">
                    <el-input-number v-model="settings.temperature" size="small" />
                    <el-slider v-model="settings.temperature" :min="0" :max="1" :step="0.01"></el-slider>
                </el-form-item>
                <el-form-item label="topN" v-if="settings.value === 'knowledge'">
                    <el-input-number v-model="settings.topN" size="small" />
                    <el-slider v-model="settings.topN" :min="1" :max="20" :step="1"></el-slider>
                </el-form-item>
            </el-form>
            <div class="el-drawer-footer-btn">
                <el-button @click='close'>取消</el-button>
                <el-button type='primary' @click='confirm'>确认</el-button>
            </div>
        </el-drawer>
</template>
<script>
import modelAPI from '@/api/model.api.js';
export default {
    name: 'ModalBox',
    data () {
        return {
            settings: {},
            show: false,
            title: '模型参数设置',
            promptTemplate: null
        };
    },
    methods: {
        open (item) {
            console.log('aa', item);
            if (!item) return;
            this.show = true;
            this.title = '模型参数设置-' + item.title;
            if (item.promptTemplate) {
                this.promptTemplate = item.promptTemplate;
            } else {
                this.promptTemplate = null;
            }
            this.settings = {
                promptTemplate: this.promptTemplate,
                value: item.value,
                ...item.modelSettings
            };
        },
        close () {
            this.show = false;
        },
        async confirm () {
            // localStorage里存储maxLength、contextLimit、temperature参数设置
            this.$store.commit('appSettings/changeModelSettings', this.settings);
            // 调用接口修改模型提示词
            if (this.promptTemplate) {
                this.promptTemplate = this.settings.promptTemplate;
                let res = await modelAPI.updatePromptTemplate(this.promptTemplate);
                if (res.data) {
                    this.$message.success('模型参数修改成功');
                } else {
                    this.$message.error('模型参数修改失败: ' + res.opDesc);
                }
            } else {
                this.$message.success('模型参数修改成功');
            }
            this.$emit('changeModelSetting');
            this.close();
        }
    }
};
</script>
<style lang="scss" scoped>
.model-setting-drawer {
    ::v-deep .el-drawer__body {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    padding: 0;
    overflow: auto;
    .el-drawer-footer-btn {
        border-top: 1px solid rgba(0, 0, 0, 0.09);
        padding: 8px 24px;
        display: flex;
        justify-content: flex-end;
    }
    .el-drawer-content {
        flex: 1;
        padding-right: 20px;
        overflow: auto;
    }
}
    ::v-deep{
        .el-input-number{
            width: 110px;
            }
        .el-slider{
            padding-left: 20px;
            display:inline-block;
            vertical-align: bottom;
            width:calc(100% - 110px);
        }
    }
}
</style>
